import * as React from 'react';
import { UserModel, UserDataModel } from 'franke-trough-dependencies';
import './UserListItem.scss';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { filter as _filter } from 'lodash';
import classNames from 'classnames';
import tickRounded from '../../../../assets/images/icons/tick-rounded.svg';
import plusRounded from '../../../../assets/images/icons/plus-rounded.svg';
import { userIsInternal, userIsSalesRep } from '../utils';
 
export interface UserListItemProps {
  user: UserModel;
  drilledAddUser?: (user: UserModel) => void;
  dispatch: any;
  language: GlobalPrivateState['localize']['language'];
}

export class UserListItemAddPartial extends React.Component<UserListItemProps, any> {
  constructor(props: UserListItemProps) {
    super(props);
  }

  public render() {
    const user = this.props.user;
    const userData = (user.userData as UserDataModel);
    const firstName = userData && userData.firstName;
    const lastName = userData && userData.lastName;
    const country = userData && userData.country.split('-')[1];
    const registration = userData && new Date(userData.created_at).toLocaleDateString(this.props.language.selected, {timeZone: 'UTC'});
    const labour = userData && userData.labour || '';
    const role = userIsInternal(user) ? 'internal' : userIsSalesRep(user) ? 'salesrep' : 'external';
    
    return (
      <li key={user.id} className={classNames(
        'user-list-item user-list-item--add', {
          'user-list-item--clickable': this.props.drilledAddUser
        })}>
        <div className="user-list-item__header">
          <span className="user-list__first" title={firstName}>{firstName}</span>
          <span className="user-list__last" title={lastName}>{lastName}</span>
          <span className="user-list__email" title={user.email}>{user.email}</span>
          <span className="user-list__country">{country}</span>
          <span className="user-list__registration">{registration}</span>
          <span className="user-list__labour">{labour}</span>
          <span className="user-list__role">{role}</span>
          <span className="user-list__action"></span>
          <span className="user-list__action">
            <img 
              className="img-fluid" 
              src={this.props.drilledAddUser ? plusRounded : tickRounded}
              alt="login"
              onClick={(e) => this.props.drilledAddUser && this.props.drilledAddUser(user)}
            />
          </span>
        </div>
      </li>
    );
  }
}

export const UserListItemAdd = connect((state: GlobalPrivateState) => ({
  language: state.localize.language,
  usersAdminList: state.users,
  queryState: state.queryState
}))(UserListItemAddPartial);

export default UserListItemAdd;
